export default __webpack_public_path__ + "static/media/Grid.b39af7c6.svg";